<template>
  <div class="homeBox app-content">
    <el-carousel class="carouselBox" height="400px">
      <el-carousel-item v-for="(item,index) in imgUrl" :key="index">
        <img :src="item.image" alt="">
      </el-carousel-item>
    </el-carousel>
    <div class="home-content">
      <div class="content-box">
        <div class="title">
          <div>推荐课程</div>
          <div class="lookMore" @click="lookMore('/curriculum')">更多课程</div>
        </div>
        <cur-list v-if="currList.length > 0" :curriculumData="currList"></cur-list>
        <div v-else class="noList">暂未上传课程</div>
      </div>
      <div class="content-box">
        <div class="title">
          <div>名师专区</div>
          <div class="lookMore" @click="lookMore('/teachers')">查看更多</div>
        </div>
        <teachers-list v-if="teachersData.length > 0" :teachersList="teachersData"></teachers-list>
        <div v-else class="noList">暂未上传名师资料</div>
      </div>
      <div class="content-box">
        <div class="title">
          <div>新闻公告</div>
          <div class="lookMore" @click="lookMore('/newsBulletin')">更多</div>
        </div>
<!--        <div class="news-box">-->
<!--          <ul class="right-news">-->
<!--            <li class="list-content">-->
<!--              <div class="img-box">-->
<!--                <img src="../../static/img/new.jpg" alt="">-->
<!--              </div>-->
<!--              <div>-->
<!--                <div class="titleII" @click="lookMore('/newsBulletin')">山西技通天下在线学习平台公告</div>-->
<!--                <div class="content" @click="lookMore('/newsBulletin')">为响应山西省职业技能线上培训工作，推动“人人持证、技 能社会”建设，创新职业技能培训方式，提高信息化水平，提供 便捷高效的培训平台，助力全民技能提升培训。山西技通天下在线学习平台特推出各个技能工种，供广大学员在线学习。-->
<!--                  在线工种课程学习注册流程及学习课程质量控制</div>-->
<!--                <div class="time">2020.8.1发布     技通天下发布</div>-->
<!--                <div></div>-->
<!--              </div>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </div>-->
        <div class="news-box" v-if="newsList.length > 0">
          <div class="left-news">
            <img :src="newsList2[0].url" alt="">
            <div class="titleI" @click="newClick(newsList2[0].formUrl)">{{newsList2[0].title}}</div>
            <div class="time">{{newsList2[0].time}}</div>
            <div class="content">{{newsList2[0].content}}</div>
          </div>
          <ul class="right-news">
            <li class="list-content" v-for="(item, key) in newsList" :key="key">
              <div class="img-box">
                <img :src="item.url" alt="">
              </div>
              <div>
                <div class="content" @click="newClick(item.formUrl)">{{item.title}}</div>
                <div class="time">
                  <div>{{item.time}}</div>
                  <div>最新资讯</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div v-else class="noList">暂未上传新闻资讯</div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import { mapMutations } from 'vuex'
import curList from '../components/curList'
import teachersList from '../components/teachersList'
// const curriculumData = require('../../mock/curriculumData.json')
const newsList1 = require('../../mock/newsList.json')
// const teacher = require('../../mock/teacher.json')

export default {
  name: 'home',
  data () {
    return {
      imgUrl: [
        {image: '../../static/img/banner3.jpg'},
        {image: '../../static/img/banner4.jpg'},
        {image: '../../static/img/banner7.jpg'},
        {image: '../../static/img/banner8.png'}
      ],
      currList: [],
      teachersData: [],
      newsList: newsList1.data.slice(1, 5),
      newsList2: newsList1.data.slice(0, 1)
    }
  },
  components: {
    curList,
    teachersList
  },
  mounted () {
    this.getCurList()
    this.getTeacher(1)
    // this.getNews()
  },
  methods: {
    ...mapMutations(['setActiveIndex']),
    // 获取课程列表
    getCurList () {
      let that = this
      this.$http({
        method: 'get',
        url: '/api/renren-fast/app/olcurriculum/pushList',
        params: {
          'page': 1,
          'limit': 4
        }
      }).then((result) => {
        console.log(result)
        that.currList = result.data.page.olCurriculum
      })
    },
    getTeacher (page) {
      let that = this
      this.$http({
        method: 'get',
        url: '/api/renren-fast/app/olteacher/list',
        params: {
          'page': page,
          'limit': 4
        }
      }).then((result) => {
        that.teachersData = result.data.data.list
      })
    },
    // // 获取新闻资讯
    // getNews () {
    //   let that = this
    //   axios({
    //     method: 'get',
    //     url: '/th/newsList'
    //   }).then((result) => {
    //     that.newsList = result.data.data.data.slice(0, 4)
    //   })
    // },
    lookMore (start) {
      this.setActiveIndex(start)
      this.$router.push(start)
    },
    newClick (url) {
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.homeBox{
  .home-content{
    width: 1200px;
    margin: 0 auto;
    .content-box{
      margin: 30px 0px;
      .title{
        font-size: 24px;
        font-weight: bold;
        color: #666;
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
        .lookMore{
          padding: 0 10px;
          height: 24px;
          line-height: 22px;
          text-align: center;
          color: #ce443a;
          border: 1px solid #ce443a;
          border-radius: 12px;
          font-size: 14px;
          cursor: pointer;
        }
      }
      .news-box{
        display: flex;
        .left-news{
          width: 500px;
          img{
            width: 100%;
            height: 260px;
          }
          .titleI{
            font-size: 18px;
            margin: 10px 0px;
            cursor: pointer;
            &:hover{
              color: #00c5c3;
            }
          }
          .time{
            font-size: 12px;
            color: #999999;
            margin-bottom: 5px;
          }
          .content{
            font-size: 12px;
            color: #666666;
          }
        }
        .right-news{
          margin-left: 50px;
          width: 560px;
          .list-content{
            margin-bottom: 10px;
            display: flex;
            .img-box{
              width: 160px;
              height:88px;
              flex-shrink: 0;
              margin-right: 20px;
              img{
                width: 100%;
                height: 100%;
              }
            }
            .content{
              width: 400px;
              text-overflow: ellipsis;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              line-height: 20px;
              margin-bottom: 10px;
              cursor: pointer;
              &:hover{
                color: #00c5c3;
              }
            }
            .time{
              color: #333333;
              font-size: 12px;
            }
          }
        }
      }
      .noList{
        width: 100%;
        height: 200px;
        text-align: center;
        line-height: 200px;
        font-size: 24px;
        color: #999999;
      }
    }
  }
}
</style>
<style>
.carouselBox .el-carousel__item img{
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/home.vue